import React, { useState } from 'react'
import {
  StyledTab,
  SubmitFlex,
  MenuFlex,
} from 'modules/Roles/Partials/RolesInfoTable/Style/style'
import FilterDiv from 'components/FilterDiv'
import Button from 'components/Button'
import JobTypeFilter from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/JobTypeFilter'
import HireFilter from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/HiresFilter'
import LocationFilter from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/LocationFilter'
import SalaryFilter from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/SalaryFilter'

const { TabPane } = StyledTab

const RoleFilter = ({ setQuery, citiesList, getCities, setFilterQuery }) => {
  const [filters, setFilters] = useState({})
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [jobTypeValue, setJobTypeValue] = useState([])
  const [hireValue, setHireValue] = useState([])
  const [location, setLocation] = useState([])
  const onJobTypeChange = status => {
    if (status?.length) {
      setJobTypeValue([status[status?.length - 1]])
      let jobType = status[status?.length - 1]
      setFilters(prev => {
        return { ...prev, jobType }
      })
    } else {
      setJobTypeValue([])
      let filterCopy = { ...filters }
      if (filterCopy && (filterCopy?.jobType || filterCopy?.jobTypeLevel)) {
        delete filterCopy?.jobType
        delete filterCopy?.jobTypeLevel
      }
      setFilters(filterCopy)
    }
  }

  const onHireValueChange = status => {
    if (status.length) {
      let val = status[status.length - 1].split('-')
      setHireValue([status[status.length - 1]])
      setFilters(prev => {
        return { ...prev, minVacancies: val[0], maxVacancies: val[1] }
      })
    } else {
      setJobTypeValue([])
      let filterCopy = { ...filters }
      delete filterCopy.maxVacancies
      delete filterCopy.minVacancies
      setFilters(filterCopy)
      setHireValue([])
    }
  }
  const onLocationChange = location => {
    if (location.length) {
      setLocation(location)
      setFilters(prev => {
        return { ...prev, cities: location }
      })
    } else {
      setLocation([])
      let filterCopy = { ...filters }
      delete filterCopy.cities
      setFilters(filterCopy)
    }
  }
  const onSalaryChange = val => {
    setFilters(prev => {
      return {
        ...prev,
        minCTC: val.minValue,
        maxCTC: val.maxValue,
      }
    })
  }
  const submitFilter = () => {
    if (Object.keys(filters).length) {
      let queryParams = ''
      Object.keys(filters).forEach(val => {
        queryParams = `${queryParams}${val}=${filters[val]}&`
      })
      queryParams = queryParams.substring(0, queryParams.length - 1)
      setFilterQuery(queryParams)
      setIsMenuOpen(false)
    } else {
      setFilterQuery('')
    }
    setIsMenuOpen(false)
    setFlag(true)
  }
  const menu = (
    <MenuFlex column>
      <StyledTab border={true} tabPosition={'left'} type="card">
        <TabPane tab="Job Type" key="1">
          <JobTypeFilter setJobType={onJobTypeChange} value={jobTypeValue} />
        </TabPane>
        <TabPane tab="No of Hires" key="2">
          <HireFilter setHire={onHireValueChange} value={hireValue} />
        </TabPane>
        <TabPane tab="Location" key="3">
          <LocationFilter
            setLocation={onLocationChange}
            citiesList={citiesList}
            getCities={getCities}
            value={location}
          />
        </TabPane>
        <TabPane tab="Salary" key="4">
          <SalaryFilter setSalaryChange={onSalaryChange} />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setIsMenuOpen(false)
          }}
        />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <FilterDiv
      overlayMenu={menu}
      open={isMenuOpen}
      setOpen={flag => {
        setIsMenuOpen(flag)
      }}
    />
  )
}

export default RoleFilter
